import token, { tokenToVars } from '../token';
import Popover from './popover';

export { Popover };
export default tokenToVars(Popover, token);
